export default __webpack_public_path__ + "5473a291b9e9d1b638fde88ee8949b78.jpg";